exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../../../css-loader/dist/cjs.js??ref--7-oneOf-2-1!../../../../../postcss-loader/src/index.js??postcss!./backdrop-theme.css"), "");

// Module
exports.push([module.id, ".c-backdrop {\n  background-color: var(--tws-backdrop-background-color);\n  bottom: 0;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n", ""]);

